import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';

export default {
    methods: {
        // POST http://agentapi.app.iqeq.cn/api/Baby/ZqwPlatform_Baby_Add  联帮接口

        Baby_Add() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession
            };
            $http.post2("api/Baby/ZqwPlatform_Baby_Add", Object.assign({}, params, this.form)).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '添加成功',
                        type: 'success'
                    });
                    this.$emit('getBabyList', this.form.BabyName)
                    this.dialogVisible = false

                });
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/LBHomeOrder/components/addBaby/services.js